import { render, staticRenderFns } from "./MpChooseListV2.vue?vue&type=template&id=13316123&scoped=true&"
import script from "./MpChooseListV2.vue?vue&type=script&lang=js&"
export * from "./MpChooseListV2.vue?vue&type=script&lang=js&"
import style0 from "./MpChooseListV2.vue?vue&type=style&index=0&id=13316123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13316123",
  null
  
)

export default component.exports